// extracted by mini-css-extract-plugin
export var tosLink = "_dy-0";